
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
:host{
  box-sizing:border-box;
  display:inline-flex;
}
:host *,
:host *::before,
:host *::after{
  box-sizing:inherit;
}
:host([aria-hidden='true']),
[aria-hidden='true'],
.visually-hidden{
  position:absolute !important;
  overflow:hidden;
  clip:rect(1px, 1px, 1px, 1px);
  width:1px;
  height:1px;
  word-wrap:normal;
}
.sr-only{
  position:absolute !important;
  overflow:hidden;
  clip:rect(1px, 1px, 1px, 1px);
  width:1px;
  height:1px;
  word-wrap:normal;
}
.dropdown{
  display:flex;
  position:relative;
}
.dropdown--open .dropdown__panel{
  margin:0;
  position:absolute;
  z-index:50;
  min-width:100%;
  background-color:var(--outline-white);
  color:var(--outline-black);
  pointer-events:all;
  box-shadow:0 10px 20px rgba(0, 0, 0, 0.1), 0 6px 6px rgba(0, 0, 0, 0.1);
  border-radius:0 0 0.4rem 0.4rem;
}
li{
  position:relative;
  padding:var(--spacing-2) var(--spacing-4);
  transition:all 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  color:var(--brand-dark-blue-900);
}
li:last-child{
    border-radius:0 0 0.4rem 0.4rem;
  }
li:not(:first-child)::before{
      content:'';
      position:absolute;
      top:0;
      left:0;
      width:100%;
      height:3px;
      background-color:var(--brand-gray-400);
      transition:background-color 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275);
    }
li:not(:first-child):hover::before{
      background-color:var(--brand-dark-blue-900);
    }
li:hover{
    background-color:var(--brand-dark-blue-900);
    color:var(--outline-white);
  }
li a{
    white-space:nowrap;
    font-family:var(--ff-display);
  }
.mobile{
  width:100%;
}
.dropdown__trigger,
outline-button-baseline{
  width:100%;
}
`;